import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import template from "./list_facet.html";

function Facet(search_model, facet, expanded, active, custom, is_control) {
    facet.data = facet.data || [];
    var thisFacet = this;
    Object.assign(this,  {
        "type": "single",
        "template": template,
        "caption": facet.caption,
        "name": facet.name,
        "icon": facet.icon,
        "colour": facet.colour || "light-sea-green",
        "custom": custom,
        "show_aggregate": facet.show_aggregate !== false,
        "data": ko.observableArray($.map(facet.data, function (value) {
            if (value.count) {
                //ensure this is not already active
                var selector = facet.name + ":" + value.key;
                if (active.indexOf(selector) < 0)
                    return {
                        "key": value.key,
                        "value": value.count > 0 ? value.count : null,
                        "caption": value.caption
                    };
            }
            return null;
        })),
        "visible": ko.pureComputed(function() {
            return search_model.dynamic_faceting() || thisFacet.data().length > 0;
        }),
        "expandable": true,
        "is_control": is_control === true,
        "value": ko.observable(null)
    });

    var f = this;
    this.selectFacet = function (data) {
        f.value(data);
        //var selector = facet.name == "facet_queries" ? data.key : ("{!tag=" + facet.name + "}" + facet.name + ":" + data.key);
        var selector = f.name == "facet_queries" ? data.key : (f.field || f.name) + ":" + data.key;
        search_model.faceting.active.push({
            "name": f.name,
            "value": data.key,
            "valueCaption": data.caption,
            "selector": selector,
            "caption": facet.caption,
            "join": facet.join
        });
        f.data.remove(data);
        search_model.pager.start_index(0);
        search_model.query_results();
    };
    this.expanded = ko.observable(expanded || is_control);
    this.expand = function () {
        f.expanded(!f.expanded());
        if (f.expanded() && search_model.dynamic_faceting()) {
            search_model.query_results();
        }
    };

}

export default Facet;